export const redirectTo = {
    super_admin: '/admin',
    entrepreneur_admin: '/admin/assessment-users',
    udc_admin: '/org-dashboard',
    Student: '/dashboard',
    prolific_admin: '/org-dashboard',
    entrepreneur: '/entrepreneur'
}
